import z from "zod";

export const payoutSettingsEntityType = "worker-payout-settings";
export const externalAccountsEntityType = "worker-external-payment-account";

// GET/PATCH /accounts/{workerId}/payout-settings types
export const payoutCapabilitySchema = z.enum(["instant", "standard", "none"]);
export const payoutScheduleSchema = z.enum(["instant", "standard"]);

export type PayoutCapability = z.infer<typeof payoutCapabilitySchema>;
export type PayoutSchedule = z.infer<typeof payoutScheduleSchema>;

export const payoutSettingsAttributesSchema = z.object({
  payoutSchedule: payoutScheduleSchema,
  preferredExternalAccountStripeId: z.string().optional(),
});
export const payoutSettingsMetaSchema = z.object({
  payoutCapability: payoutCapabilitySchema,
  instantPayoutFee: z.number(),
});

export const payoutSettingsQuerySchema = z
  .object({
    include: z.enum([externalAccountsEntityType]).optional(),
  })
  .optional();

// GET /accounts/{workerId}/external-accounts types
export type PayoutSettingsAttributes = z.infer<typeof payoutSettingsAttributesSchema>;

export const externalAccountListingAttributesSchema = z.object({
  stripeId: z.string(),
  type: z.enum(["card", "bank"]),
  last4: z.string(),
  providerName: z.string().optional(), // MasterCard, Visa, Chase, etc.
  supportsInstantPayouts: z.boolean(),
});

export type ExternalAccount = z.infer<typeof externalAccountListingAttributesSchema>;

export type ExternalAccountLite = Pick<ExternalAccount, "type" | "providerName" | "last4">;

// GET /accounts/{workerId}/external-accounts/{stripeId} types
export const externalAccountDetailsAttributesSchema = z.object({
  stripeId: z.string(),
  type: z.enum(["card", "bank"]),
  last4: z.string(),
  providerName: z.string().optional(), // MasterCard, Visa, Chase, etc.
  // TODO(VAU-888): Make this required once the migration is complete
  // https://linear.app/clipboardhealth/issue/VAU-888/save-and-return-the-new-supportsinstantpay-for-all-new-external
  supportsInstantPayouts: z.boolean().optional(),
});

export const externalAccountDetailsSchema = z.object({
  id: z.string(),
  type: z.literal(externalAccountsEntityType),
  attributes: externalAccountDetailsAttributesSchema,
});

export type ExternalAccountDetailsAttributes = z.infer<
  typeof externalAccountDetailsAttributesSchema
>;
